import { FieldArray, useFormikContext } from 'formik'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FormAddAnotherButton } from './FormAddAnotherButton'
import { FormDeleteFieldButton } from './FormDeleteFieldButton'
import { SearchableSelect } from './SearchableSelect'
import { AuthContext, ROLE } from 'src/contexts/authContext'
import { CFormInput } from '@coreui/react-pro'
import { FormLabel } from 'src/components/forms/FormLabel'

export default function FormSelectMultipleMFPartners({
  manufacturerOptions,
  readOnly,
  setInitialvaluesChanged,
  setIsLoading,
  mfPartnerMappings,
  setMfPartnerMappings,
}) {
  const { t } = useTranslation()
  const auth = useContext(AuthContext)

  manufacturerOptions = manufacturerOptions.map((partner) => {
    return { label: partner.name, value: partner.id }
  })
  const {
    values: { partners, branches, mfPartners },
    setFieldValue,
  } = useFormikContext()
  let manufacturers_count = 0

  const findErpBCId = (mfId) => {
    const setting = mfPartnerMappings.find((erpOption) => erpOption.partnerId === mfId)
    return setting ? setting.erpBCId : ''
  }

  const mfERPIdOnChange = async (input) => {
    const position = parseInt(input.target.id.split('.')[1])
    let localMapper = mfPartnerMappings
    localMapper[position].erpBCId = input.target.value
    setMfPartnerMappings(localMapper)
  }

  return (
    <>
      {(auth.role === ROLE.CUBOTOO_ADMIN || auth.role === ROLE.BUILDING_CONTRACTOR_ADMIN) && (
        <p className="spartan-font">{'Manufacturer ERP IDs'}</p>
      )}
      {(auth.role === ROLE.CUBOTOO_ADMIN || auth.role === ROLE.BUILDING_CONTRACTOR_ADMIN) && (
        <FieldArray
          name={'mfPartners'}
          render={({ push, remove }) => (
            <>
              {!!manufacturerOptions.length &&
                mfPartners.map((mfPartner, idx) => {
                  const options = manufacturerOptions
                  const hasMfPartnerOptions = options.map((pr) => pr.value).includes(mfPartner)
                  manufacturers_count =
                    mfPartner === ''
                      ? manufacturers_count + 1
                      : hasMfPartnerOptions
                      ? manufacturers_count + 1
                      : manufacturers_count
                  return (
                    <>
                      {((!readOnly && mfPartner === '') || hasMfPartnerOptions) && (
                        <div key={idx} className="w-2 h-2 position-relative">
                          <p className="spartan-font">
                            {mfPartners.length === 1
                              ? t('Backoffice.Wizard.AddPartner.Type.MF')
                              : `${t(
                                  'Backoffice.Wizard.AddPartner.Type.MF',
                                )} (${manufacturers_count})`}
                          </p>
                          <SearchableSelect
                            className="my-2 form-control-backoffice"
                            placeholder={t('Backoffice.Wizard.AddPartner.Type.MF')}
                            name={`mfPartners.${idx}`}
                            id={`mfPartners.${idx}`}
                            options={options}
                            disabled={readOnly}
                            mfCase={true}
                            mfPartnerMappings={mfPartnerMappings}
                            setMfPartnerMappings={setMfPartnerMappings}
                          />
                          {!readOnly && mfPartners.length > 0 && (
                            <FormDeleteFieldButton
                              index={idx}
                              handleClick={async () => {
                                setIsLoading(true)
                                remove(idx)
                                const updatedMfPartners = [...mfPartners]
                                updatedMfPartners.splice(idx, 1)
                                setFieldValue('mfPartners', updatedMfPartners)
                                setInitialvaluesChanged(true)
                                const updatedMfPartnerMappings = [...mfPartnerMappings]
                                updatedMfPartnerMappings.splice(idx, 1)
                                setMfPartnerMappings(updatedMfPartnerMappings)
                                setIsLoading(false)
                              }}
                            />
                          )}
                          <div>
                            <p className="w-2 h-2 position-relative">
                              <CFormInput
                                floatingLabel={'ERP BC ID'}
                                type={'text'}
                                disabled={readOnly}
                                id={`mfErpId.${idx}`}
                                placeholder={'ERP BC ID'}
                                name={`mfErpId.${idx}`}
                                defaultValue={findErpBCId(mfPartner)}
                                onChange={(e) => mfERPIdOnChange(e)}
                              />
                            </p>
                          </div>
                        </div>
                      )}
                    </>
                  )
                })}
              {!readOnly && <FormAddAnotherButton push={push} values={''} />}
            </>
          )}
        />
      )}
    </>
  )
}
